var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.style},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://www.buymeacoffee.com/salteadorneo","target":"_blank"}},[_c('img',{staticStyle:{"height":"50px !important","width":"178px !important"},attrs:{"src":"https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png","alt":"Buy Me A Coffee"}})])
}]

export { render, staticRenderFns }